import { createFileRoute } from '@tanstack/react-router'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { ROLE_CREATE } from '~/components/routes/administration/roles/permissions'
import { RoleForm } from '~/components/routes/administration/roles/role-form'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/administration/roles/new')({
  staticData: { permission: ROLE_CREATE },
  component: AdministrationRoleCreatePage,
})
withRoutePermissions(Route)

function AdministrationRoleCreatePage() {
  return (
    <>
      <AppHeader>
        <Title>Administration</Title>
      </AppHeader>

      <AppContainer>
        <RoleForm mode="create" />
      </AppContainer>
    </>
  )
}
